<div class="mt-1">
  <p class="fw-bold mr-1 mt-0 text-align-right">
    Net Amount
    <span class="fw-normal ml-1">£ {{ netAmount | numberPipe }}</span>
  </p>
  <p class="fw-bold mr-1 mt-0 text-align-right">
    VAT Amount
    <span class="fw-normal ml-1">£ {{ vatAmount | numberPipe }}</span>
  </p>
  <p class="fw-bold mr-1 mt-0 text-align-right">
    Total Amount <span class="fw-normal ml-1">£ {{ total | numberPipe }}</span>
  </p>
  <p class="fw-bold mr-1 text-align-right" *ngIf="showBalanceDue">
    Balance Due
    <span class="fw-normal ml-1">£ {{ balanceAmount | numberPipe }}</span>
  </p>
</div>
